export * from './component';



// WEBPACK FOOTER //
// ./src/components/hls-player/index.ts